module.exports = __webpack_public_path__ + "img/flot1.34d7f337.svg";